import React from 'react';

export enum Job {
  Teikihoan = 'teikihoan',
  Kaisen = 'kaisen',
  Heisen = 'heisen',
  Event = 'event',
}

export enum TransitionSource {
  Hp = 'hp',
  Line = 'line',
  Web = 'web',
}

export type OptionType = {
  id: string;
  value: string;
  isDisabled: boolean;
}[];

export enum ButtonType {
  OkOnly = 'OkOnly',
  YesNo = 'YesNo',
}
export type DialogInfoType = {
  isOpen: boolean;
  title: string;
  message: string;
  type: ButtonType;
  onaccept: (e: React.FormEvent<HTMLFormElement>) => void;
  onclose: () => void;
};

export type inputInfo = {
  subtitle: string;
  value: string;
}[];

export type ReceiveTeihoReceptionType = {
  token: string;
  is_web_hidamari_entry: boolean;
  customer_no: string;
  kyokyusaki_no: string;
  request_date_day: string;
  request_date_time: string;
  request_date_time_cd: string;
  tachiaisha_kbn_cd: string;
  tachiaisha_kbn_name: string;
  tachiaisha_name: string;
  tachiaisha_phone_no: string;
  customer_name: string;
  customer_name_kana: string;
  post_no: string;
  gyosei_shi_ku_name: string;
  gyosei_cho_name: string;
  chomoku_banchi: string;
  heya_no: string;
  tel_no: string;
  mail_address: string;
  encrypt_mail_address: string;
  transition_source: string;
  tenken_yotei_eigyosho_cd: string;
  yoyaku_sbt_cd: YoyakuSbtKbn;
  sakujo_sgn: boolean;
};

export enum GyomuCD {
  kaisen = '01',
  heisen = '02',
  shuri = '04',
  hoan = '05',
}

//#region 立会者区分
export enum TachiaishaKbn {
  self = 'ご本人',
  family = 'ご家族',
  agent = '代理人',
  other = 'その他',
}

export enum TachiaishaKbnCD {
  self = '01',
  family = '02',
  agent = '03',
  other = '99',
}

export const getOmoshideshaCD = (omoshideshaKbn: string): TachiaishaKbnCD => {
  switch (omoshideshaKbn) {
    case TachiaishaKbn.self:
      return TachiaishaKbnCD.self;
    case TachiaishaKbn.family:
      return TachiaishaKbnCD.family;
    case TachiaishaKbn.agent:
      return TachiaishaKbnCD.agent;
    case TachiaishaKbn.other:
      return TachiaishaKbnCD.other;
    default:
      return TachiaishaKbnCD.other;
  }
};
//#endregion

//#region 時間帯
export enum TimeZoneKbn {
  am1 = '9:00～11:00',
  am2 = '10:00～12:00',
  pm1 = '13:00～15:00',
  pm2 = '15:00～17:00',
}
//#endregion

export enum YoyakuSbtKbn {
  // 予約申込区分
  nodata = '', // 未選択
  teikihoan = '100', // 定期保安
  kaisen = '200', // 開栓
  heisen = '300', // 閉栓
  event = '400', // イベント
}

export const getYoyakuKbn = (gyomu: Job): YoyakuSbtKbn => {
  switch (gyomu) {
    case Job.Teikihoan:
      return YoyakuSbtKbn.teikihoan;
    case Job.Kaisen:
      return YoyakuSbtKbn.kaisen;
    case Job.Heisen:
      return YoyakuSbtKbn.heisen;
    case Job.Event:
      return YoyakuSbtKbn.event;
  }
};

export type NavigateState = {
  source: string | null;
  gyomu: string | null;
  token: string | null;
  mailaddress: string | null;
  yoyakudata?: string | null;
  step?: number;
  prepage?: string;
  customer_no?: string | null;
  kyokyusaki_no?: string | null;
  uketsuke_no?: string | null;
  function?: string;
  event_sbt?: string | null;
  guid?: string | null; //2024.09 COMTEC kawaji ADD
  msg?: string | null; //2024.09 COMTEC kawaji ADD
};

export const ComCubeConnectSbtList: YoyakuSbtKbn[] = [
  YoyakuSbtKbn.teikihoan,
  YoyakuSbtKbn.kaisen,
  YoyakuSbtKbn.heisen,
];

export type ReceiveEventReceptionType = {
  token: string;
  uketsuke_no: string;
  p_customer_no: string;
  yoyaku_sbt_cd: string;
  event_sbt_cd: string;
  event_no: string;
  // event_name: string;
  request_date_day_cd: number;
  // request_date_day: string;
  request_date_time_cd: number;
  // request_date_time_name: string;
  customer_name: string;
  customer_name_kana: string;
  customer_family_name: string;
  customer_first_name: string;
  customer_family_name_kana: string;
  customer_first_name_kana: string;
  attendance: number;
  attendance_adults: number;
  attendance_kids: number;
  remarks: string;
  event_status_cd: string;
  post_no: string;
  gyosei_shi_ku_name: string;
  gyosei_cho_name: string;
  chomoku_banchi: string;
  heya_no: string;
  tel_no: string;
  mail_address: string;
  transition_source: string;
  sakujo_sgn: boolean;
};
